import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { IResponse } from 'src/app/shared/models/app';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { AccountService } from './account.service';
import {  Subject } from 'rxjs';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheConstant } from '../cache/cache.constant';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PrincipalService extends BaseService {
  _identity: any;
  _authenticated = false;
  authenticated$: Subject<boolean> = new Subject();

  /*********************Properties*********************/

  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(protected http: HttpClient, 
    private accountService: AccountService,
    private cacheService: CacheResolverService,
    private sessionStorage:SessionStorageService,) {
    super(http);
  }
  //apiUrl: any = 'https://arcos-report-dev.apps.cf.np.gc.cahcloud.net/api/';


  // authenticate() {
  //   this.identity();
  // }

  identity(shipTo = null,removeCache = false) {

    return new Promise((resolve, reject) => {
       this.accountService.get(shipTo,removeCache).subscribe((response: IResponse) => {
        if (response && response.data) {
          this._identity = response.data;
          this._identity.permissions = response.data.permissions;
          this._identity.licenseModules = response.data.licenseData;
          this._identity.invoicePermission = response.data.invoicePermission;
          this._identity.email = response.data.emailId;
          this._authenticated = true;
          this.authenticated$.next(true);
          this._identity.nuctracEssential = false;
          response.data.licenseData.modules.forEach(module => {
            if (module.id === 5) {
              this._identity.nuctracEssential = true;
            }
          });
        }else{
            this.accountService.getEnvironment('logouturl').subscribe((resp:IResponse)=>{
          let url=resp.data.value;
           window.location.href =  url;
        });
        }
        this.cacheService.set('Identity', this._identity);
        this.cacheService.set('Authenticated', this._authenticated);
        this.cacheService.set(CacheConstant.LocalStorage.NuctracEssentials,this._identity.nuctracEssential);
        resolve(this._identity);
      });
    });

  }

  hasPermission(permissionList) {
    const permissions =this.sessionStorage.retrieve(CacheConstant.SessionStorageData.Permissions);
    if(permissionList){
      for (let i = 0; i < permissionList.length; i++) {
        if ( permissions && permissions.indexOf(permissionList[i]) !== -1) {
            return true;
        }
    }
    }else{
      return true;
    }

  return false;
  }

  hasLicenseModule(moduleId){
    let retVal = false;
    let identity = this.cacheService.get('Identity');

    if(this._identity){
      retVal = this.hasIdentityModule(this._identity,moduleId);
    }
    else if(identity){
      retVal = this.hasIdentityModule(identity,moduleId);
    }
    return retVal;
  }

  private hasIdentityModule(identity:any,moduleId:number):boolean{
    let retVal = false;
    if(identity && identity.licenseModules && identity.licenseModules.modules && identity.licenseModules.modules.length > 0){
      identity.licenseModules.modules.forEach((module)=>{
        if(module.id==moduleId){
          retVal=true;
        }
      });
    }
    return retVal;
  }

  getEnvironment(url){
    return super.fetch(this.apiConfig.util +'/api/environment'+'?type='+url);
  }

  getLogoutEnvironment(logoutMethod,userId,userEmail){
    return super.fetch(this.apiConfig.util +'/api/environment'+'?type=logouturl',{
      headers: {
        'logout-method' : logoutMethod,
        'user-id' : userId,
        'user-email' : userEmail
      }
    });
  }

}
